import api from "@/services/api/api-cbrAcc"
import CbrAccModel, { CBR_ACC } from "./models/CbrAccModel"
import CbrAvailabilityModel from "./models/CbrAvailabalityModel"

export default class CbrAccService {
  async list(query) {
    try {
      let res = await api.list(query)
      if(!res) throw new Error('Something wrong and account not loaded. Please, reload page or try later.')
      let data = {
        results: res.map( item => new CbrAccModel(item)),
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async listAvaliability(query) {
    try {
      let res = await api.listAvaliability(query)
      if(!res) throw new Error('Something wrong and account not loaded. Please, reload page or try later.')
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async importAccounts(ids) {
    try {
      let res = await api.importAccounts({ids: ids})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateCourseLocations(ID, data) {
    try {
      let res = await api.updateCouseLocations(ID, {
        [CBR_ACC.COURSE_LOCATIONS]: data.locations,
        [CBR_ACC.FOR_RESERVATION_SYSTEM]: data.forReservationSystem,
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateProducts(ID, products) {
    try {
      let res = await api.patch(ID, {
        products: products
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }
}